<template>
  <footer class="bg-white pt-10 pb-4">
    <div class="container mx-auto px-4">
      <!-- Grid principal -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        <!-- Sobre la compañía -->
        <div>
          <h3 class="text-lg font-bold text-darkblue-700 mb-4">Sobre {{ account?.name }}</h3>
          <img :src="account?.logo ?? 'logo.png'" :alt="`Logo ${account?.name}`" class="h-12 mb-4" />
          <p class="text-gray-600 text-sm">
            {{ account?.description ?? 'Herramienta para la gestión empresarial, fuerza de venta y distribuidores...' }}
          </p>
        </div>

        <!-- Menú destacados -->
        <div>
          <h3 class="text-lg font-bold text-darkblue-700 mb-4">Destacados</h3>
          <ul class="space-y-2">
            <li><a href="/web/products?featured=1" class="text-gray-600 hover:text-sky-500">Productos Destacados</a></li>
            <li><a href="/web/products?new=1" class="text-gray-600 hover:text-sky-500">Nuevos Productos</a></li>
            <li><a href="/web/products?offers=1" class="text-gray-600 hover:text-sky-500">Ofertas</a></li>
            <li><a href="/web/products?best_sellers=1" class="text-gray-600 hover:text-sky-500">Más Vendidos</a></li>
          </ul>
        </div>

        <!-- Legales -->
        <div>
          <h3 class="text-lg font-bold text-darkblue-700 mb-4">Legales</h3>
          <ul class="space-y-2">
            <li><Link href="/terms" class="text-gray-600 hover:text-sky-500">Términos y Condiciones</Link></li>
            <li><Link href="/privacy" class="text-gray-600 hover:text-sky-500">Política de Privacidad</Link></li>
            <li><Link href="/shipping" class="text-gray-600 hover:text-sky-500">Política de Envíos</Link></li>
            <li><Link href="/returns" class="text-gray-600 hover:text-sky-500">Devoluciones</Link></li>
          </ul>
        </div>

        <!-- Redes sociales -->
        <div>
          <h3 class="text-lg font-bold text-darkblue-700 mb-4">Síguenos</h3>
          <div class="flex space-x-4">
            <a href="https://instagram.com/#" target="_blank" class="text-gray-600 hover:text-sky-500">
              <i class="fa fa-instagram text-2xl"></i>
            </a>
          </div>
          <div class="mt-4">
            <h4 class="font-bold text-gray-700 mb-2">Contáctanos</h4>
            <p class="text-gray-600 text-sm">
              <i class="fa fa-phone mr-2"></i> {{ account?.phone }}
            </p>
            <p class="text-gray-600 text-sm">
              <i class="fa fa-envelope mr-2"></i> {{ account?.email }}
            </p>
          </div>
        </div>
      </div>

      <!-- Línea divisoria -->
      <div class="border-t border-gray-200 pt-4">
        <!-- Copyright y créditos -->
        <div class="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
          <p>&copy; {{ new Date().getFullYear() }} {{ account?.name }} Todos los derechos reservados.</p>
          <p class="mt-2 md:mt-0">
            Corriendo con tecnología de <a href="https://realgestion.conexioncreativa.net" target="_blank" class="text-sky-500 hover:text-sky-600">Realgestión</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
  name: 'FooterWeb',
  components: { Link },
  props: {
    account: Object
  }
}
</script>